import { Stack, Card, Heading } from "@twilio/flex-ui/node_modules/@twilio-paste/core";
import { ParticipantDetails } from "../../../types/ParticipantDetails";
import { Participant } from "./Participant/Participant";

interface ParticipantsProps {
  participantDetails: ParticipantDetails[];
  handleKickParticipant: (interactionParticipantSid: string) => void;
}

export const Participants = ({ participantDetails, handleKickParticipant }: ParticipantsProps) => {
  const participants = participantDetails.map((participantDetail, index) => {
    const { participantType } = participantDetail;
    const { isMe } = participantDetail;
    const allowKick = !isMe && participantType === "agent";
    const participantName = participantDetail.friendlyName;
    const { interactionParticipantSid } = participantDetail;

    return (
      <Participant
        key={index}
        name={participantName}
        participantType={participantType}
        allowKick={allowKick}
        handleKickParticiant={() => handleKickParticipant(interactionParticipantSid)}
      />
    );
  });

  return (
    <Card padding="space60">
      <Heading as="h2" variant="heading20">
        Participants
      </Heading>
      <Stack orientation="vertical" spacing="space20">
        {participants}
      </Stack>
    </Card>
  );
};
